import { PlanLimitExceededSource } from "store/entities/subscriptions";

import { SubscriptionViewAction, SubscriptionViewActionsNames } from "./actions";

export interface ISubscriptionViewState {
  focusedColumn: number;
  upsellModal: {
    open: boolean;
    source: PlanLimitExceededSource | null;
  };
}

const initialState: ISubscriptionViewState = {
  focusedColumn: 1,
  upsellModal: {
    open: false,
    source: null,
  },
};

const subscriptionViewReducer = (
  state: ISubscriptionViewState = initialState,
  action: SubscriptionViewAction
): ISubscriptionViewState => {
  switch (action.type) {
    case SubscriptionViewActionsNames.SET_FOCUSED_COLUMN: {
      const { focusedColumn } = action.payload;
      return { ...state, focusedColumn };
    }

    case SubscriptionViewActionsNames.CLOSE_UPSELL_MODAL: {
      return { ...state, upsellModal: { open: false, source: null } };
    }

    case SubscriptionViewActionsNames.OPEN_UPSELL_MODAL: {
      return {
        ...state,
        upsellModal: {
          open: true,
          source: action.payload.source,
        },
      };
    }

    default:
      return state;
  }
};
export default subscriptionViewReducer;
